import * as questionIds from "../../questions/questionIds";

const declarationOfHealthQuestions = [
    {
        id: questionIds.Declaration1,
        questionText: "I declare that the information I have provided in this form is true and accurate to the best of my belief and knowledge.",
    }
];

export { declarationOfHealthQuestions };
